
import { bindActionCreators } from 'redux';
import { connect }            from 'react-redux';
import * as actions           from '../../redux/modules/actions';
import TeamMatesView          from './TeamMates';

const mapStateToProps = (state) => {
  return {
    currentView:  state.views.currentView
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions : bindActionCreators(
      {
        enterTeamMatesView: actions.enterTeamMatesView,
        leaveTeamMatesView: actions.leaveTeamMatesView
      },
      dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeamMatesView);



// WEBPACK FOOTER //
// ./src/app/views/teamMates/index.js